import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const TermsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 10px 0;
  margin-top: 2rem;
  font-family: Montserrat, sans-serif;
`;

const TermsCheckbox = styled.input`
  margin-right: 8px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #007bff;
  transform: scale(1.2);
`;

const TermsLabel = styled.label`
  cursor: pointer;
`;

const AgreeToTerms = ({ isAgreed, onChange }) => {
  const { t } = useTranslation();

  const handleLink = (path) => {
    window.open(path, "_blank");
  };

  return (
    <TermsContainer className="terms-checkbox">
      <TermsCheckbox
        type="checkbox"
        id="terms-agreement"
        checked={isAgreed}
        onChange={(e) => onChange(e.target.checked)}
      />
      <TermsLabel htmlFor="terms-agreement">
        <span>{t("common.Iagree")} </span>
        <span
          onClick={() => handleLink("/terms-and-conditions")}
          style={{
            color: "#007bff",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {t("HomePageRedesign.termsAndConditions")}
        </span>
        <span> {t("common.and")} </span>
        <span
          onClick={() => handleLink("/privacy")}
          style={{
            color: "#007bff",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {t("HomePageRedesign.privacyPolicy")}
        </span>
      </TermsLabel>
    </TermsContainer>
  );
};

export default AgreeToTerms;
